// @flow

export default (t: (id: string, obj?: Object) => string) => ({
  id: {
    "ui:widget": "hidden",
  },
  "ui:order": [
    "name",
    "addressLine1",
    "postCode",
    "reseller",
    "accountManager",
    "inTesting",
    "status",
    "country",
    "region",
    "*",
  ],
  addressLine1: {
    "ui:options": {
      label: t("CLIENT_ADDRESS"),
      description: t("CLIENT_ADDRESS_DESCRIPTION"),
      className: "mb-2",
    },
  },
  addressLine2: {
    "ui:widget": "hidden",
  },
  addressLine3: {
    "ui:widget": "hidden",
  },
  city: {
    "ui:widget": "hidden",
  },
  postCode: {
    "ui:options": {
      description: t("CLIENT_POST_CODE_DESCRIPTION"),
    },
  },
  name: {
    "ui:options": {
      description: "The name of the client. It will automatically be at the top of the hierarchy.",
    },
  },
  inTesting: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("SUPPRESSION"),
      description: t("CLIENT_SUPPRESSION_DESCRIPTION"),
    },
  },
  accountManager: {
    id: {
      "ui:options": {
        label: t("ACCOUNT_MANAGER"),
        description: t("CLIENT_MANAGER_DESCRIPTION"),
      },
    },
  },
  status: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("STATUS"),
      description: t("CLIENT_STATUS_DESCRIPTION"),
    },
  },
  reseller: {
    id: {
      "ui:options": {
        label: t("CONTRACT_OWNER"),
        description: t("CLIENT_OWNER_DESCRIPTION"),
      },
    },
  },
  sector: {
    "ui:options": {
      description: t("CLIENT_SECTOR_DESCRIPTION"),
    },
  },
  industry: {
    id: {
      "ui:options": {
        description: t("CLIENT_INDUSTRY_DESCRIPTION"),
      },
    },
  },
  country: {
    id: {
      "ui:header": t("BENCHMARKING_CLASSIFICATIONS"),
      "ui:options": {
        description: t("CLIENT_COUNTRY_DESCRIPTION"),
        header: {
          backgroundColor: "white",
          type: "h4",
        },
      },
    },
  },
  region: {
    id: {
      "ui:options": {
        description: t("CLIENT_REGION_DESCRIPTION"),
      },
    },
  },
});
